export default function isAuthenticated() {
  const token = JSON.parse(localStorage.getItem('token'));

  if (token && token.token) {
    return true;
  } else {
    return false;
  }
}
